module.exports = __webpack_public_path__ + "img/step38_a_printer_power_open_roll_cover_remove_tapes_retainers - Copy.96a4a26f.png";